import {
    apiRequest,
    dukList,
} from "../../../../../services/adapters/kepegawaian/dukService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", dukList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository